// Reducer

import { REQUEST, SUCCESS, FAILURE } from 'app/shared/util/action-type.util';
import { ACTION_TYPES } from './actions';
import { ContractState, initialState } from './state';

export default (state: ContractState = initialState, action): ContractState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.GET_CLAIMS_SUBSCRIPTION_BY_NUMBER):
      return {
        ...state,
      };

    case SUCCESS(ACTION_TYPES.GET_CLAIMS_SUBSCRIPTION_BY_NUMBER): {
      return {
        ...state,
        subscriptionModel: { ...state.subscriptionModel, claimNumberList: action.payload.data },
        respondingSubscriptionBN: true,
      };
    }

    case FAILURE(ACTION_TYPES.GET_CLAIMS_SUBSCRIPTION_BY_NUMBER): {
      return {
        ...initialState,
      };
    }

    case REQUEST(ACTION_TYPES.GET_SUBSCRIPTION_BY_CLIENT):
      return {
        ...state,
        loading: true,
        isReady: false,
      };

    case SUCCESS(ACTION_TYPES.GET_SUBSCRIPTION_BY_CLIENT): {
      return {
        ...state,
        subscriptionList: action.payload.data,
        loading: false,
        isReady: true,
        page: 1,
      };
    }

    case FAILURE(ACTION_TYPES.GET_SUBSCRIPTION_BY_CLIENT): {
      return {
        ...initialState,
        loading: false,
        isReady: true,
      };
    }

    case REQUEST(ACTION_TYPES.GET_SUBSCRIPTION_BY_NUMBER):
      return {
        ...state,
        subsByNumberLoading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_SUBSCRIPTION_BY_NUMBER): {
      return {
        ...state,
        subscriptionModel: { ...state.subscriptionModel, subscriptionSelected: action.payload.data },
        subsByNumberLoading: false,
      };
    }

    case FAILURE(ACTION_TYPES.GET_SUBSCRIPTION_BY_NUMBER): {
      return {
        ...initialState,
        subsByNumberLoading: false,
      };
    }

    case REQUEST(ACTION_TYPES.UPDATE_INFO_CLIENT):
      return {
        ...state,
        loading: true,
        updated: false,
      };

    case SUCCESS(ACTION_TYPES.UPDATE_INFO_CLIENT): {
      return {
        ...state,
        subscriptionModel: {
          ...state.subscriptionModel,
          subscriptionSelected: { ...state.subscriptionModel.subscriptionSelected, subscriber: action.payload.data },
        },
        loading: false,
        updated: true,
      };
    }

    case FAILURE(ACTION_TYPES.UPDATE_INFO_CLIENT): {
      return {
        ...state,
        loading: false,
        updated: false,
      };
    }

    case REQUEST(ACTION_TYPES.GET_PRODUCT_OFFRE):
      return {
        ...state,
        productOffreLoading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_PRODUCT_OFFRE): {
      return {
        ...state,
        subscriptionModel: { ...state.subscriptionModel, productOffer: action.payload.data },
        productOffreLoading: false,
      };
    }

    case FAILURE(ACTION_TYPES.GET_PRODUCT_OFFRE): {
      return {
        ...state,
        productOffreLoading: false,
      };
    }

    case REQUEST(ACTION_TYPES.GET_CONTRACTUEL_DOCUMENTS):
      return {
        ...state,
        contractuelDocumentsLoading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_CONTRACTUEL_DOCUMENTS): {
      return {
        ...state,
        subscriptionModel: { ...state.subscriptionModel, ContractualDocuments: action.payload.data },
        contractuelDocumentsLoading: false,
      };
    }

    case FAILURE(ACTION_TYPES.GET_CONTRACTUEL_DOCUMENTS): {
      return {
        ...state,
        contractuelDocumentsLoading: false,
      };
    }

    case ACTION_TYPES.SET_PAGE: {
      return {
        ...state,
        page: action.payload.page,
      };
    }

    case ACTION_TYPES.RESET_CONTRACT: {
      return {
        ...initialState,
      };
    }
    case ACTION_TYPES.RESET_USER_INFO: {
      return {
        ...state,
        updated: false,
      };
    }

    case REQUEST(ACTION_TYPES.GET_LIST_IMPYE_INFO):
      return {
        ...state,
        listImpyeLoading: true,
      };

    case SUCCESS(ACTION_TYPES.GET_LIST_IMPYE_INFO): {
      return {
        ...state,
        listImpyeLoading: false,
        listImpaye: action.payload.data,
      };
    }

    case FAILURE(ACTION_TYPES.GET_LIST_IMPYE_INFO): {
      return {
        ...initialState,
        listImpyeLoading: false,
      };
    }

    case REQUEST(ACTION_TYPES.RECOVER_ACTIVATE_SUBSCRIPTIONS):
      return {
        ...state,
        loading: true,
        isReady: false,
      };

    case SUCCESS(ACTION_TYPES.RECOVER_ACTIVATE_SUBSCRIPTIONS): {
      return {
        ...state,
        subscriptionList: action.payload.data,
        loading: false,
        isReady: true,
        page: 1,
      };
    }

    case FAILURE(ACTION_TYPES.RECOVER_ACTIVATE_SUBSCRIPTIONS): {
      return {
        ...initialState,
        loading: false,
        isReady: true,
      };
    }

    default:
      return state;
  }
};
